import React from "react";
import Carousel from "./Carousel";
import { useQuery } from "@apollo/client";
import { GET_IMAGES_QUERY } from "../LongformGallery/constants";
import { shouldSkip } from "../LongformGallery/helpers";
import dynamic from 'next/dynamic';

const CarouselImage = dynamic(() =>
  import(/* webpackChunkName: "boatWebCarouselCenteredVariantCarouselImage" */ './CarouselImage')
);

// const BlazeVariant = dynamic(() =>
//   import(/* webpackChunkName: "boatWebCarouselCenteredVariantCarouselBlazeVariant" */ './BlazeVariant')
// );

const BlazeVariantTemp = dynamic(() =>
  import(/* webpackChunkName: "boatWebCarouselCenteredVariantCarouselBlazeVariantTemp" */ './BlazeVariantTemp')
);

const CenteredCarousel = (props) => {
  const {
    handleNavigation,
    imageIds,
    listRef,
    shouldDisplayCount,
    shouldDisplayCaption,
    caption,
    countMessage,
    direction,
    priorityLimit,
    modifier,
    ...otherProps
  } = props;
  const skip = shouldSkip(imageIds);

  const { data, loading, error } = useQuery(GET_IMAGES_QUERY, {
    variables: { where: { id: { _in: imageIds } } },
    skip
  });

  const { getImages } = data || {};

  if (loading || error || !getImages.length) return null;

  //todo: move order around if needed
  // const lastImage = imageIds[imageIds.length - 1];
  // const firstImages = imageIds.slice(0, -1);
  // const newImageOrder = [lastImage, ...firstImages]; // get first image centered

  const sortedImages = imageIds.map(id => getImages.find(image => image.id === id));

  return (
    <>
      <BlazeVariantTemp {...props}>
        {sortedImages.map((item, index) => (
              <CarouselImage
                key={index}
                priority={index < priorityLimit}
                {...otherProps}
                image={item}
              />
            ))}
      </BlazeVariantTemp>
    </>
  )
}

export default CenteredCarousel;

//todo: use centred carousel
 {/* <Carousel visibleItemsCount={3} isInfinite>
      {sortedImages.map((item, index, arr) => (
          <CarouselImage
            key={index}
            priority={index < priorityLimit || index === arr.length -1}
            {...otherProps}
            image={item}
          />
        ))}
    </Carousel> */}
    {/* <div className={`centered-carousel--mobile`}>
      <BlazeVariant {...props} modifier={''} />
    </div> */}
